var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$store.state.LOADING.length > 0)?_c('LoadingModal'):_vm._e(),(_vm.$store.state.ERRORS.length > 0)?_c('ErrorModal'):_vm._e(),_c('div',{staticClass:"container"},[_c('Return'),_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }